import React from 'react';
import Icon from '@/components/ui/AppIcon';

const StatsSection = () => {
  const stats = [
    {
      icon: 'DocumentTextIcon',
      value: '250+',
      label: 'Resources Available',
      description: 'Comprehensive library of guides and tools',
    },
    {
      icon: 'UserGroupIcon',
      value: '50K+',
      label: 'Active Readers',
      description: 'IT professionals trust our content',
    },
    {
      icon: 'ArrowDownTrayIcon',
      value: '100K+',
      label: 'Downloads',
      description: 'Templates and tools downloaded',
    },
    {
      icon: 'StarIcon',
      value: '4.9/5',
      label: 'Average Rating',
      description: 'Based on user feedback',
    },
  ];

  return (
    <div data-component-id="src/app/resource-center/components/StatsSection.tsx:33:4" data-component-path="src/app/resource-center/components/StatsSection.tsx" data-component-line="33" data-component-end-line="53" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-6%22%7D" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, index) => (
        <div data-component-id="src/app/resource-center/components/StatsSection.tsx:35:8" data-component-path="src/app/resource-center/components/StatsSection.tsx" data-component-line="35" data-component-end-line="51" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20rounded-lg%20shadow-card%20p-6%20text-center%20hover%3Ashadow-premium%20transition-all%20duration-300%20transform%20hover%3Ascale-105%22%7D"
          key={index}
          className="bg-card rounded-lg shadow-card p-6 text-center hover:shadow-premium transition-all duration-300 transform hover:scale-105"
        >
          <div data-component-id="src/app/resource-center/components/StatsSection.tsx:39:10" data-component-path="src/app/resource-center/components/StatsSection.tsx" data-component-line="39" data-component-end-line="41" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22inline-flex%20items-center%20justify-center%20w-14%20h-14%20bg-primary%2F10%20rounded-full%20mb-4%22%7D" className="inline-flex items-center justify-center w-14 h-14 bg-primary/10 rounded-full mb-4">
            <Icon data-component-id="src/app/resource-center/components/StatsSection.tsx:40:12" data-component-path="src/app/resource-center/components/StatsSection.tsx" data-component-line="40" data-component-end-line="40" data-component-file="StatsSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-primary%22%7D" name={stat.icon as any} size={28} className="text-primary" />
          </div>
          <div data-component-id="src/app/resource-center/components/StatsSection.tsx:42:10" data-component-path="src/app/resource-center/components/StatsSection.tsx" data-component-line="42" data-component-end-line="44" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-3xl%20font-heading%20font-bold%20text-foreground%20mb-2%22%7D" className="text-3xl font-heading font-bold text-foreground mb-2">
            {stat.value}
          </div>
          <div data-component-id="src/app/resource-center/components/StatsSection.tsx:45:10" data-component-path="src/app/resource-center/components/StatsSection.tsx" data-component-line="45" data-component-end-line="47" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-base%20font-semibold%20text-foreground%20mb-1%22%7D" className="text-base font-semibold text-foreground mb-1">
            {stat.label}
          </div>
          <p data-component-id="src/app/resource-center/components/StatsSection.tsx:48:10" data-component-path="src/app/resource-center/components/StatsSection.tsx" data-component-line="48" data-component-end-line="50" data-component-file="StatsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%22%7D" className="text-sm text-muted-foreground">
            {stat.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default StatsSection;